import React, { useEffect, useState } from "react";
import axios from "axios";
import "./AdminLove.css";

const BASE_URL =
  window.location.hostname === "localhost"
    ? "http://localhost:5000"
    : "https://success-blog-app-backend.onrender.com";

function AdminLove() {
  const [data, setData]       = useState([]);
  const [amount, setAmount]   = useState("");
  const [search, setSearch]   = useState("");
  const [filter, setFilter]   = useState("all");
  const [toast, setToast]     = useState(null);
  const [loading, setLoading] = useState(null); // id of item being processed

  useEffect(() => { fetchData(); }, []);

  const fetchData = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/api/love/all`);
      setData(res.data);
    } catch (err) { console.error(err); }
  };

  const showToast = (msg, type = "success") => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 3000);
  };

  const makePremium = async (id) => {
    if (!amount) { showToast("Enter amount first ❌", "error"); return; }
    setLoading(id);
    try {
      await axios.put(`${BASE_URL}/api/love/premium/${id}`, { amount });
      showToast("Premium set successfully ✅", "success");
      setAmount("");
      fetchData();
    } catch (err) {
      console.error(err);
      showToast("Failed to set premium ❌", "error");
    } finally {
      setLoading(null);
    }
  };

  // ── STATS ──
  const totalLove    = data.filter(d => d.type === "love").length;
  const totalFriend  = data.filter(d => d.type === "friend").length;
  const totalPremium = data.filter(d => d.premium).length;

  // ── FILTER + SEARCH ──
  const filtered = data.filter(item => {
    const matchSearch =
      (item.name1 || "").toLowerCase().includes(search.toLowerCase()) ||
      (item.name2 || "").toLowerCase().includes(search.toLowerCase());
    const matchFilter =
      filter === "all"     ? true :
      filter === "love"    ? item.type === "love" :
      filter === "friend"  ? item.type === "friend" :
      filter === "premium" ? item.premium : true;
    return matchSearch && matchFilter;
  });

  return (
    <div className="al-wrapper">

      {/* TOAST */}
      {toast && (
        <div className={`al-toast al-toast-${toast.type}`}>{toast.msg}</div>
      )}

      {/* HEADER */}
      <div className="al-header">
        <div className="al-badge">✦ Love Panel</div>
        <h2 className="al-title">Admin Love Panel</h2>
        <p className="al-sub">Manage love and friendship entries</p>
      </div>

      {/* STATS */}
      <div className="al-stats-row">
        <div className="al-stat">
          <span className="al-stat-icon">💞</span>
          <span className="al-stat-num">{data.length}</span>
          <span className="al-stat-label">Total</span>
        </div>
        <div className="al-stat">
          <span className="al-stat-icon">❤️</span>
          <span className="al-stat-num">{totalLove}</span>
          <span className="al-stat-label">Love</span>
        </div>
        <div className="al-stat">
          <span className="al-stat-icon">🤝</span>
          <span className="al-stat-num">{totalFriend}</span>
          <span className="al-stat-label">Friends</span>
        </div>
        <div className="al-stat">
          <span className="al-stat-icon">⭐</span>
          <span className="al-stat-num">{totalPremium}</span>
          <span className="al-stat-label">Premium</span>
        </div>
      </div>

      {/* CONTROLS */}
      <div className="al-controls">
        <input
          className="al-search"
          placeholder="🔍 Search by name..."
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
        <div className="al-filter-btns">
          {["all","love","friend","premium"].map(f => (
            <button
              key={f}
              className={`al-filter-btn ${filter === f ? "al-filter-active" : ""}`}
              onClick={() => setFilter(f)}
            >
              {f === "love" ? "❤️" : f === "friend" ? "🤝" : f === "premium" ? "⭐" : ""}
              {" "}{f.charAt(0).toUpperCase() + f.slice(1)}
            </button>
          ))}
        </div>
      </div>

      {/* AMOUNT INPUT */}
      <div className="al-amount-row">
        <span className="al-amount-label">💰 Set Premium Amount:</span>
        <div className="al-amount-input-wrap">
          <span className="al-rupee">₹</span>
          <input
            className="al-amount-input"
            placeholder="e.g. 499"
            type="number"
            value={amount}
            onChange={e => setAmount(e.target.value)}
          />
        </div>
        <p className="al-amount-hint">Enter amount above, then click "Make Premium" on any row</p>
      </div>

      {/* TABLE */}
      <div className="al-table-wrap">
        <table className="al-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Name 1</th>
              <th>Name 2</th>
              <th>Type</th>
              <th>Premium</th>
              <th>Amount</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 ? (
              <tr><td colSpan={7} className="al-empty">No entries found</td></tr>
            ) : filtered.map((item, i) => (
              <tr key={item._id} className={item.premium ? "al-premium-row" : ""}>
                <td className="al-td-num">{i + 1}</td>
                <td>
                  <span className="al-name">{item.name1}</span>
                </td>
                <td>
                  <span className="al-name">{item.name2}</span>
                </td>
                <td>
                  <span className={`al-type-badge ${item.type === "love" ? "al-type-love" : "al-type-friend"}`}>
                    {item.type === "love" ? "❤️ Love" : "🤝 Friend"}
                  </span>
                </td>
                <td>
                  <span className={`al-premium-badge ${item.premium ? "al-premium-yes" : "al-premium-no"}`}>
                    {item.premium ? "⭐ Yes" : "No"}
                  </span>
                </td>
                <td>
                  <span className="al-amount-cell">
                    {item.amount > 0 ? `₹${item.amount}` : "—"}
                  </span>
                </td>
                <td>
                  <button
                    className="al-btn"
                    onClick={() => makePremium(item._id)}
                    disabled={loading === item._id}
                  >
                    {loading === item._id ? (
                      <><span className="al-spinner" /> Setting...</>
                    ) : (
                      <>⭐ Make Premium</>
                    )}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

    </div>
  );
}

export default AdminLove;